<template>
  <!-- Your print-friendly content goes here -->
  <div v-if="template" :style="printCSS" id="lessonTemplatePrinterExample">
    <div>
      <v-row no-gutters class="py-2">
        <v-col cols="5" class="py-0 d-flex flex-column">
          <span v-if="template.subject" class="font-weight-bold">{{
            headingValue("Grade") +
            " " +
            template.subject.grade +
            " " +
            template.subject.subject
          }}</span>
          <span class="font-weight-bold">{{ template.name }}</span>
        </v-col>
        <v-col cols="5" class="py-0 d-flex flex-column">
          <span class="font-weight-bold">{{ headingValue("Date") }}:</span>
          <span class="font-weight-bold">{{ headingValue("Term") }}:</span>
          <span class="font-weight-bold"
            >{{ headingValue("Total") }}:&emsp;&emsp;/{{
              template.totalPoints
            }}</span
          >
          <span class="font-weight-bold">{{
            headingValue("Time") + ": " + formattedTotalTime
          }}</span>
        </v-col>
        <v-col cols="2" class="py-0 d-flex flex-column align-end">
          <div v-if="lessonImgSrc !== ''" class="pb-2">
            <img :src="lessonImgSrc" style="max-height: 48px" />
          </div>
          <div>
            <img src="@/assets/logo-v2-long.svg" style="max-height: 48px" />
          </div>
        </v-col>
      </v-row>

      <hr class="my-1" />

      <div v-if="template.template?.length > 0">
        <div
          v-for="(section, sectionIndex) in template.template"
          :key="sectionIndex"
        >
          <h2>{{ section.name }}</h2>

          <div v-for="(field, fieldIndex) in section.fields" :key="fieldIndex">
            <p>
              {{
                field.label
                /* + ' - ' + headingValue("Difficulty") + ': ' + field.difficulty */
              }}
            </p>

            <div v-if="field.images?.length > 0" class="mt-2">
  <div v-for="imageObj in field.images" :key="imageObj.key" class="mb-2">
    <img 
  :src="imageUrls[imageObj.key]"
  :style="{
    width: (imageObj.naturalWidth * (imageObj.scale / 100)) + 'px',
    'max-width': '-webkit-fill-available',
    height: 'auto'
  }"
  v-if="imageUrls[imageObj.key]"
/>
  </div>
</div>

            <textarea class="mb-4" style="text-decoration: underline;
            resize: none;
            outline: none;
            field-sizing: content;
            line-height: 1.5;" 
            readonly
            :value="formattedFieldValue(field.value)">
            </textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { Storage } from "aws-amplify";

export default {
  name: "LessonTemplatePrinterExample",
  props: {
    template: Object, // JSON object to be printed
    fontSize: {
      type: Number,
      default: 12,
    }, // Font size to be used in the content
    lessonImgSrc: {
      type: String,
      default: "",
    },
    fetchImages: {
      type: Boolean,
      default: false,
    },
  },
  data() {
      return {
        imageUrls: {},
      };
  },
  methods: {
    formattedFieldValue(fieldValue) {
      return Array.isArray(fieldValue)
        ? fieldValue.map(String).join(", ")
        : fieldValue;
    },

    async loadAllImageUrls() {
      if (!this.template?.template) return;

      const currentKeys = new Set();
      const fetchPromises = [];

      for (const section of this.template.template) {
        if (section.fields) {
          for (const field of section.fields) {
            if (field.images && field.images.length > 0) {
              for (const image of field.images) {
                currentKeys.add(image.key);
                if (!this.imageUrls[image.key]) {
                  fetchPromises.push(
                    Storage.get(image.key, { level: 'public' })
                      .then(url => {
                        this.$set(this.imageUrls, image.key, url);
                      })
                      .catch(error => {
                        console.error('Error loading image:', error);
                      })
                  );
                }
              }
            }
          }
        }
      }

      await Promise.all(fetchPromises);

      // Clean up removed images
      for (const key in this.imageUrls) {
        if (!currentKeys.has(key)) {
          this.$delete(this.imageUrls, key);
        }
      }
    },
  },
  computed: {
    formattedTotalTime() {
      const totalMinutes =
        typeof this.template.minutes !== "string"
          ? this.template.minutes
          : parseInt(this.template.minutes);
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      if (hours === 0) {
        return `${minutes} Minute${minutes > 1 ? "s" : ""}`;
      } else if (minutes === 0) {
        return `${hours} Hour${hours > 1 ? "s" : ""}`;
      } else {
        return `${hours} Hour${hours > 1 ? "s" : ""} ${minutes} Minute${
          minutes > 1 ? "s" : ""
        }`;
      }
    },
    printCSS() {
      if (this.template.fontFamily && this.template.fontFamily !== "Default") {
        return {
          fontSize: this.fontSize + "px",
          fontFamily: this.template.fontFamily,
        };
      } else return { fontSize: this.fontSize + "px" };
    },
    headingValue() {
      return (param) => {
        if (this.template.headings) {
          const foundItem = _.find(this.template.headings, { label: param });
          return foundItem ? foundItem.value : param;
        } else return param;
      };
    },
  },
  watch: {
  fetchImages: {
    handler: async function(newVal) {
      if (newVal) {
        console.log('fetchImages')
        await this.loadAllImageUrls();
      }
    }
  },
  template: {
    handler: async function(newVal) {
      if (newVal && newVal.template) {
        await this.loadAllImageUrls();
      }
    },
    immediate: true
  }
},
};
</script>

<style></style>
